import { LinearGradient } from 'expo-linear-gradient';
import type { FC } from 'react';
import { StyleSheet } from 'react-native';

import { useGetOwnChats } from '@/features/api/hooks/grapevine-chat/useGetOwnChats';
import type { ChatsRoute } from '@/features/chats/navigation/chatsRoute';
import { ChatListItem } from '@/features/profile-setting/components/ChatListItem';
import { ProfileSettingRoute } from '@/features/profile-setting/navigation/profileSettingRoute';
import type { AppNativeStackScreenProps } from '@/navigation/types/navigation';
import { StateView } from '@/shared/components/state-view/StateView';
import { useRefetchOnFocus } from '@/shared/hooks/useRefetchOnFocus';
import { hasItems } from '@/shared/utils/array';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

const styles = StyleSheet.create({
  gradient: { flex: 1 },
  list: { marginVertical: 0 },
  empty: { paddingHorizontal: 16 },
  iconStyle: { width: 40, height: 40, margin: 0 }
});

type Props = AppNativeStackScreenProps<typeof ChatsRoute.ChatArchive>;

export const ChatArchiveScreen: FC<Props> = ({ navigation }) => {
  const theme = useAppTheme();

  const query = useGetOwnChats();
  const { data, isPending, refetch } = query;

  const chats = data?.filter((c) => c.archived);

  useRefetchOnFocus(query);

  if (!hasItems(chats)) navigation.popTo(ProfileSettingRoute.Chats);

  return (
    <LinearGradient
      style={styles.gradient}
      colors={[
        theme.colors.surfaceContainer,
        theme.colors.secondaryContainer,
        theme.colors.secondaryContainer
      ]}
    >
      <StateView
        isLoading={isPending}
        onRefetch={refetch}
        backgroundColor="transparent"
      >
        {hasItems(chats) &&
          chats?.map((chat) => <ChatListItem key={chat.id} chat={chat} />)}
      </StateView>
    </LinearGradient>
  );
};
